<template>
  <b-navbar toggleable="lg" type="light" variant="light" class="site-navbar">
    <b-navbar-brand>
      <router-link to="/" class="brand-link">
        <span class="brand-main">JPFC</span>
        <span class="brand-sub">Workforce</span>
      </router-link>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ms-auto align-items-center">
        <b-nav-item class="nav-item-aligned">
          <router-link to="/pricing" class="nav-link px-3">
            Pricing
          </router-link>
        </b-nav-item>

        <!-- Show for logged-in users -->
        <template v-if="isAuthenticated">
          <b-nav-item class="nav-item-aligned">
            <router-link to="/companydashboard" class="nav-link px-3">
              Dashboard
            </router-link>
          </b-nav-item>

          <b-nav-item class="nav-item-aligned">
            <router-link to="/operationsdashboard" class="nav-link px-3">
              Employees
            </router-link>
          </b-nav-item>

          <b-nav-item-dropdown
            right
            class="nav-item-aligned"
            menu-class="mt-2"
          >
            <template #button-content>
              <i class="fa fa-user" aria-hidden="true"></i>
              {{ userName }}
            </template>

            <b-dropdown-item href="/myprofile">Profile</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>

        <!-- Show for logged-out users -->
        <template v-else>
          <b-nav-item class="nav-item-aligned">
            <router-link to="/login" class="nav-link px-3">
              Login
            </router-link>
          </b-nav-item>

          <b-nav-item class="nav-item-aligned">
            <router-link to="/registercompany" class="nav-link cta-link">
             Register 
            </router-link>
          </b-nav-item>
        </template>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },

    userName() {
      const userString = localStorage.getItem('user');
      const user = userString ? JSON.parse(userString) : null;
      return user?.fullname || user?.username || user?.email || '';
    }
  },

  methods: {
    checkTokenExpiration() {
      const issuedAt = localStorage.getItem('jwt_issued_at');
      if (!issuedAt) return false;

      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - Number(issuedAt);
      const oneHour = 60 * 60 * 1000;

      if (elapsedTime > oneHour) {
        this.logout();
        return false;
      }

      return true;
    },

    logout() {
      localStorage.removeItem('jwt');
      localStorage.removeItem('jwt_issued_at');
      localStorage.removeItem('role');
      localStorage.removeItem('user');

      this.$store.commit('logout');
      this.$router.push({ name: 'myhome' });
    }
  },

  created() {
    this.checkTokenExpiration();
  }
};
</script>

<style scoped>
.site-navbar {
  padding: 0.85rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.brand-link {
  text-decoration: none;
  display: inline-flex;
  align-items: baseline;
  gap: 0.35rem;
}

.brand-main {
  font-weight: 800;
  color: #111827;
  font-size: 1.1rem;
}

.brand-sub {
  font-weight: 500;
  color: #6b7280;
  font-size: 1.05rem;
}

.navbar-nav.align-items-center {
  align-items: center !important;
}

.nav-item-aligned {
  display: flex;
  align-items: center;
}

.nav-item-aligned .nav-link,
.nav-item-aligned .dropdown-toggle {
  padding: 0.5rem 1rem;
  line-height: 1.5;
  display: flex;
  align-items: center;
}

.navbar-nav .nav-link {
  color: #374151;
  font-weight: 500;
  text-decoration: none;
}

.navbar-nav .nav-link:hover,
.navbar-nav .router-link-active {
  color: #2563eb;
}

.cta-link {
  background: #2563eb;
  color: white !important;
  padding: 0.5rem 0.9rem !important;
  border-radius: 0.55rem;
  margin-left: 0.5rem;
  font-weight: 700;
}

.cta-link:hover {
  background: #1d4ed8;
  color: white !important;
}

.dropdown-toggle::after {
  vertical-align: middle;
  margin-left: 0.5rem;
}

@media (max-width: 991px) {
  .cta-link {
    margin-left: 0;
    margin-top: 0.5rem;
    display: inline-block;
  }
}
</style>
